<span class="mpp-checkbox-marker__container">
  <span class="mpp-checkbox-marker__icon-wrapper">
    <span class="mpp-checkbox-marker__icon icon icon-tick-bold" data-type="checked"></span>

    <span class="mpp-checkbox-marker__icon icon icon-minus-bold" data-type="indeterminate"></span>
  </span>

  <span class="mpp-checkbox-marker__overlay"></span>
</span>
